import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { UserApi } from '@/type';
import { apiOf } from '@/util';

export const getDetail = apiOf<
  UserApi.GetDetail.Request,
  UserApi.GetDetail.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/user/:id' }));

export const getList = apiOf<UserApi.GetList.Request, UserApi.GetList.Response>(
  new AxiosGetRequestOptions({ url: '/v1/miri/user' }),
);

export const getCount = apiOf<
  UserApi.GetCount.Request,
  UserApi.GetCount.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/user/count' }));

export const update = apiOf<UserApi.Update.Request, UserApi.Update.Response>(
  new AxiosPutRequestOptions({ url: '/v1/miri/user/:id' }),
);

export const remove = apiOf<UserApi.Remove.Request, UserApi.Remove.Response>(
  new AxiosDeleteRequestOptions({ url: '/v1/miri/user/:id' }),
);
